import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useClipboard } from 'use-clipboard-copy';
import { useNetwork, useSpace } from '@tribeplatform/react-sdk/hooks';
import { Divider } from '@tribeplatform/react-ui-kit/Divider';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { Input } from '@tribeplatform/react-ui-kit/Input';
import { Link } from '@tribeplatform/react-ui-kit/Link';
import { Slider } from '@tribeplatform/react-ui-kit/Slider';
import { Toggle } from '@tribeplatform/react-ui-kit/Toggle';
import { ErrorBoundary } from '../common/components/ErrorBoundary';
import { T } from '../i18n';
import { SpaceTagSelector } from '../Space/SpaceTagSelector';
const toQueryString = obj => Object.keys(obj)
    .map(key => `${key}=${obj[key]}`)
    .join('&');
const getIframe = (iframeSrc, { height, title }) => {
    return `<iframe frameborder="no" src="${iframeSrc}" height="${height}px" width="100%" title="${title}" />`;
};
export const SpaceEmbedCreator = ({ spaceId }) => {
    const [copied, setCopied] = useState(false);
    const clipboard = useClipboard();
    const { data: space, isFetching: fetchingSpace } = useSpace({
        variables: { id: spaceId },
    });
    const { data: network, isFetching: fetchingNetwork } = useNetwork();
    const loading = fetchingNetwork || fetchingSpace;
    const [tag, setTag] = useState();
    const baseUrl = `https://${network.domain}/embed/space/${space === null || space === void 0 ? void 0 : space.slug}`;
    const [iframeHeight, setIframeHeight] = useState(360);
    const [iframeSrcParams, setIframeSrcParams] = useState({
        readonly: true,
        header: true,
        composer: true,
    });
    const iframeSrc = `${baseUrl}?${toQueryString(iframeSrcParams)}`;
    const set = (key, value) => {
        setIframeSrcParams({
            ...iframeSrcParams,
            [key]: value,
        });
    };
    const unset = (key) => {
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { [key]: _deletedKey, ...rest } = iframeSrcParams;
        setIframeSrcParams(rest);
    };
    if (loading) {
        return (_jsx("div", { className: "flex justify-center items-center w-full h-96", children: _jsx(SpinnerIcon, { className: "animate-spin absolute h-9 w-9" }, void 0) }, void 0));
    }
    const iframeToCopy = getIframe(iframeSrc, {
        height: iframeHeight,
        title: space === null || space === void 0 ? void 0 : space.name,
    });
    return (_jsxs(_Fragment, { children: [_jsx(Input, { onClick: e => e.currentTarget.select(), value: iframeToCopy, readOnly: true, trailingAddon: _jsx(Link, { onClick: () => {
                        clipboard.copy(iframeToCopy);
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                    }, variant: "neutral", children: _jsx(T, { id: "Generics.CopyTooltip", defaultMessage: "{copied, select, true {Copied} other {Copy}}", values: { copied } }, void 0) }, void 0) }, void 0), _jsx(Divider, {}, void 0), _jsxs("div", { className: "mb-3 space-y-5", children: [_jsxs("div", { className: "flex justify-between items-center", children: [_jsx("h5", { children: _jsx(T, { defaultMessage: "Show header", id: "ShareModal.SpaceEmbedCreator.ShowHeader" }, void 0) }, void 0), _jsx(Toggle, { checked: iframeSrcParams.header, onChange: () => {
                                    set('header', !iframeSrcParams.header);
                                } }, void 0)] }, void 0), _jsxs("div", { className: "flex justify-between items-center", children: [_jsx("h5", { children: _jsx(T, { defaultMessage: "Show composer", id: "ShareModal.SpaceEmbedCreator.ShowComposer" }, void 0) }, void 0), _jsx(Toggle, { checked: iframeSrcParams.composer, onChange: () => {
                                    set('composer', !iframeSrcParams.composer);
                                } }, void 0)] }, void 0), _jsxs("div", { className: "flex justify-between items-center", children: [_jsx("h5", { children: _jsx(T, { defaultMessage: "Read-only", id: "Generics.ReadOnly" }, void 0) }, void 0), _jsx(Toggle, { checked: iframeSrcParams.readonly, onChange: () => {
                                    set('readonly', !iframeSrcParams.readonly);
                                } }, void 0)] }, void 0), _jsxs("div", { className: "flex justify-between items-center", children: [_jsx("h5", { children: _jsx(T, { defaultMessage: "{TAG_CC}", id: "Generics.Tag" }, void 0) }, void 0), _jsx("div", { className: "w-52", children: _jsx(SpaceTagSelector, { spaceId: space === null || space === void 0 ? void 0 : space.id, selectedTag: tag, onSelect: tag => {
                                        setTag(tag);
                                        if (!tag) {
                                            unset('tag');
                                            unset('tag_id');
                                        }
                                        else {
                                            set('tag', tag.slug);
                                        }
                                    } }, void 0) }, void 0)] }, void 0)] }, void 0), _jsx("h5", { children: _jsx(T, { defaultMessage: "Embed height: {iframe_height}px", id: "Share.EmbedHeight", values: {
                        iframe_height: iframeHeight,
                    } }, void 0) }, void 0), _jsx("div", { className: "mb-2", children: _jsx(Slider, { value: iframeHeight, step: 10, min: 200, max: 1000, onChange: setIframeHeight }, void 0) }, void 0), _jsxs(ErrorBoundary, { children: [_jsx(T, { defaultMessage: "Embed preview", id: "Share.EmbedPreview" }, void 0), _jsx("h5", { className: "mb-1" }, void 0), _jsx("div", { className: "p-3 bg-skeleton overflow-auto h-96 rounded-md", children: _jsx("iframe", { src: iframeSrc, height: `${iframeHeight}px`, width: "100%", title: space === null || space === void 0 ? void 0 : space.name }, void 0) }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=SpaceEmbedCreator.js.map